<template>
    <transition
        enter-from-class="opacity-0"
        enter-to-class="opacity-100"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
    >
        <div
            v-if="amsSearchStore.isFetching"
            data-component="AmsResultlistLoadingSpinner"
            class="absolute duration-300 w-full h-full bg-white bg-opacity-90 z-overlay-canvas"
        >
            <cs-loading-spinner class="top-[150px]">
                <p class="whitespace-nowrap">Deine Ergebnisse werden geladen</p>
            </cs-loading-spinner>
        </div>
    </transition>
</template>
<script setup lang="ts">
import { CsLoadingSpinner } from '@sunrise/components'
import { useAmsSearchStore } from '../../store/amsSearch'

const amsSearchStore = useAmsSearchStore()
</script>
